export const {appConfig} = window
